module.exports = __webpack_public_path__ + "static/media/LogoEN.abac0981.svg";